'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const MarketingIntroductionSourcesSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchAllMarketingIntroductionSource, marketingIntroductionSources } = useLookupsStore()
  const [options, setOptions] = useState(testData || marketingIntroductionSources || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(marketingIntroductionSources || [])
  }, [testData, marketingIntroductionSources])

  useEffect(() => {
    if (testData || marketingIntroductionSources?.length) return
    fetchAllMarketingIntroductionSource()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, marketingIntroductionSources])

  useEffect(() => {
    if (typeof value === 'number' || typeof value === 'string') {
      const selectedOption = options.find(
        (option) => String(option.marketingIntroductionSourceId) === String(value)
      )
      if (selectedOption) {
        setSelectedValue(selectedOption)
      }
    } else {
      setSelectedValue(value)
    }
  }, [value, options])

  return (
    <div
      data-testid="MarketingIntroductionSourcesSelect"
      style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}
    >
      <ReactSelectMenu
        label="Marketing introduction source"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="marketingIntroductionSourceId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="marketingIntroductionSourceId"
        showIdInResults={false}
        name="marketingIntroductionSourceId"
        size={size}
        required={required}
        errors={errors}
      />
    </div>
  )
}

MarketingIntroductionSourcesSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
